/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".payment-steps[_ngcontent-%COMP%]{list-style:none;padding:0 1em}.payment-steps[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{float:left;margin-right:.25em;opacity:.4;font-size:clamp(1rem,4vw,1.25rem);cursor:pointer}.payment-steps[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%]{opacity:1}.payment-steps[_ngcontent-%COMP%]   li.under-line[_ngcontent-%COMP%]{border-bottom:1px solid}.payment-steps[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover{opacity:1}"];
export { styles as styles };
